import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { Badge } from "./Badge";
import { ButtonBase } from "./ButtonBase";
import { OverflowingTypography } from "./OverflowingTypography";
import { ColorsProvider } from "../providers/ColorsProvider";
import { SlotsProvider } from "../providers/SlotsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
export const navigationRailCellClasses = {
    root: "MinervaNavigationRailCell-root",
    label: "MinervaNavigationRailCell-label",
    badge: "MinervaNavigationRailCell-badge",
    selected: "MinervaNavigationRailCell-selected",
    disabled: "MinervaNavigationRailCell-disabled",
};
export const navigationRailCellSlots = {
    label: OverflowingTypography,
    badge: Badge,
};
export const NavigationRailCell = (props) => {
    const { fullWidth, badge, startNode, endNode, density = "comfortable", selected, color = "surface", colorSet, invertColors, slots, slotProps, sx, className, disabled, children, ...rest } = useDefaultProps({ component: "NavigationRailCell", props });
    return (_jsx(SlotsProvider, { baseSlots: navigationRailCellSlots, slots: slots, children: ({ label: Label, badge: Badge }) => (_jsx(ColorsProvider, { color: color, colorSet: colorSet, invertColors: !invertColors, children: (colorStyles) => (_jsxs(ButtonBase, { className: clsx([
                    navigationRailCellClasses.root,
                    selected && navigationRailCellClasses.selected,
                    disabled && navigationRailCellClasses.disabled,
                    className,
                ]), sx: mergeSx({
                    padding: density === "comfortable" ? 3 : density === "dense" ? 2 : 0,
                    color: colorStyles.color,
                    backgroundColor: "transparent",
                    width: fullWidth ? "100%" : undefined,
                    borderRadius: (theme) => theme.radius.full,
                    gap: density === "comfortable" ? 2 : density === "dense" ? 1 : 0,
                    [`&.${navigationRailCellClasses.root}`]: {
                        display: "flex",
                        alignItems: "center",
                        textAlign: "left",
                    },
                    [`&.${navigationRailCellClasses.selected}`]: {
                        ...colorStyles,
                    },
                    [`&.${navigationRailCellClasses.disabled}`]: {
                        color: (theme) => theme.palette.disabled.main,
                        backgroundColor: "transparent",
                    },
                }, sx), ...rest, children: [startNode && (_jsx(Badge, { label: badge, color: "error", placement: {
                            horizontal: "left",
                            vertical: "top",
                        }, placementOffset: {
                            horizontal: -1.25,
                            vertical: -1.25,
                        }, ...slotProps?.badge, className: clsx([
                            navigationRailCellClasses.badge,
                            slotProps?.badge?.className,
                        ]), children: startNode })), typeof children === "string" ? (_jsx(Label, { variant: "body3", fontWeight: selected || disabled ? "bold" : "regular", ...slotProps?.label, className: clsx([
                            navigationRailCellClasses.label,
                            slotProps?.label?.className,
                        ]), sx: mergeSx({
                            flex: 1,
                        }, slotProps?.label?.sx), children: children })) : (children), endNode] })) })) }));
};
//# sourceMappingURL=NavigationRailCell.js.map